// 引用css
import '../scss/base.scss';
import '../scss/main.scss';
// 开发引用html，热更新
if (process.env.NODE_ENV === 'development') {
  require('raw-loader!../index.html');
  require('raw-loader!../_main.html');
}

// 兼容低版本ie
import 'es5-shim';
import 'es5-shim/es5-sham';

import * as service from './service';

// 如果需要头部脚部就打开注释
// import header from "headerES";
// var domain = "gevents.37games.com"; //ocean.location.getDomain();
//
// header.render(domain, ".cm-top-bg");
//

// import footer from "footerES";
// footer.render(domain ".j-f_common_footer");

import loading from './loading.js';
import $ from 'jquery';
import '../lib/swiper';
import '../scss/swiper.scss';
import * as interaction from './interaction.js';
import { getParam } from 'utilsES';
import language from './language';

$(function () {
  dataLayer.push({
    event: 'entrance',
    scid: getParam('scid'),
    cid: getParam('cid')
  });
  // const getBrowserLanguage = function () {
  //   if (window.navigator) {
  //     let lang =
  //       window.navigator.language ||
  //       window.navigator.browserLanguage ||
  //       window.navigator.systemLanguage;
  //     if (lang.indexOf('-') > -1) {
  //       let langArr = lang.split('-');
  //       let realLang = langArr[0].toLowerCase()
  //       return realLang;
  //     } else {
  //       let realLang = lang.toLowerCase();
  //       return realLang;
  //     }
  //   }
  // }
  
  // console.log(nlang);

  service.init();
  service.ipToLang();
  loading();
  const fullpageAPI = interaction.initFullPage();
  let nlang = service.getBrowserLanguage();
  let vlang = "";
  if (nlang.includes("vi")) {
    vlang = "vi";
  } else if (nlang.includes("th")) {
    vlang = "thai";
  } else if (nlang.includes("zh")) {
    vlang = "zh";
  } else {
    vlang = "thai";
  }
  if (!language.lang) {
    language.lang = getParam('lang') || vlang || "vi";
  }
  language.initPageLang();
    //预约人数初始化
    interaction.preNum.init();
    //觉醒次数初始化
    interaction.wakeNum.init();
    //分享初始化
    interaction.share.init();
  interaction.wake.init();
  interaction.common.init(fullpageAPI);
  interaction.menu.init(fullpageAPI);
  interaction.register.init();
  interaction.download.init(fullpageAPI);
  interaction.world.init();
    interaction.role.init();
    interaction.activities.init();
  interaction.footer.init();
});

// 商品轮播
window.addEventListener('load', () => {
  // 视频延迟加载
  const tpl = `<source src="./vedio/pc_vedio1.webm" type="video/webm">
  							<source src="./vedio/pc_vedio2.mp4" type="video/mp4">`;
  const $vedio = $('.j-vedio');
  $vedio.html(tpl);
  $vedio.on('canplay', () => {
    $('.j-vedio-container').addClass('active');
  });
});
